import { Button } from "@material-ui/core";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import CalendarTodayOutlinedIcon from "@material-ui/icons/CalendarTodayOutlined";
import moment from "moment";
import PropTypes from "prop-types";
// Material-ui datetime picker
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import "moment/locale/vi";
import "moment/locale/en-ca";
// Style
import { styles } from "./styles";
class PickerMonth extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      time: this.props.time || new Date(),
      locale: "vi",
    };
    this.handleChange = this.handleChange.bind(this);
  }
  async componentDidMount() {}
  componentWillReceiveProps(nextProps) {
    // dashboard need load state
    if (nextProps.time !== this.state.time) {
      this.setState({ time: nextProps.time });
    }
  }
  handleChange(value, nameInput) {
    const _this = this;
    let firstDayOfMonth = moment(value).startOf("month"); // get first day of select month
    firstDayOfMonth = new Date(firstDayOfMonth).getTime();
    this.setState({ time: firstDayOfMonth }, function () {
      _this.props.handleChange(firstDayOfMonth, nameInput);
    });
  }
  renderMonth = (props, month, year, selectedDate) => {
    return <td {...props}>{month + 1}</td>;
  };
  render() {
    const { classes, i18n, t, nameInput = "" } = this.props;
    const { time } = this.state;
    moment.locale(i18n.language);
    return (
      <React.Fragment>
        <MuiPickersUtilsProvider
          libInstance={moment}
          utils={MomentUtils}
          locale={i18n.language === "vn" ? "vi" : "en"}
        >
          <DatePicker
            TextFieldComponent={(props) => (
              <Button
                classes={{
                  root: classes.btnRoot,
                }}
                {...props}
                error="true"
              >
                <CalendarTodayOutlinedIcon className={classes.calendarIcon} />
                {props.value}
              </Button>
            )}
            openTo="month"
            views={["year", "month"]}
            format="MM/YYYY"
            renderMonth={this.renderMonth}
            value={time}
            onChange={(value) => this.handleChange(value, nameInput)}
            cancelLabel={t("date_picker_cancel")}
            okLabel={t("date_picker_ok")}
          />
        </MuiPickersUtilsProvider>
      </React.Fragment>
    );
  }
}

PickerMonth.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles)(PickerMonth)));
